import React, { useState } from 'react';
import { ClockIcon, DropletIcon, ZapIcon, CheckIcon, XIcon, BarChart3Icon, UserIcon, UsersIcon } from 'lucide-react';
export function Science() {
  const [showModal, setShowModal] = useState(false);
  const [activeImage, setActiveImage] = useState('');
  const openModal = imageUrl => {
    setActiveImage(imageUrl);
    setShowModal(true);
  };
  return <section className="mb-24" data-id="element-406">
      <h2 className="text-[28px] sm:text-[40px] md:text-[42px] font-semibold text-[#1B2951] mb-12 leading-tight font-['Playfair_Display']" data-id="element-407">
        The Science That Made Me Bet ₹3 Crores
      </h2>
      {/* Split Screen Comparison */}
      <div className="grid md:grid-cols-2 gap-8 mb-16 transition-all" data-id="element-408">
        {/* LEFT COLUMN - Regular Collagen */}
        <div className="bg-white p-8 rounded-lg border border-[#7F8C8D]/20 hover:shadow-lg transition-all duration-300 hover:scale-[1.02]" data-id="element-409">
          <h3 className="text-[20px] md:text-[24px] font-medium text-[#1B2951] mb-8 flex items-center font-['Poppins']" data-id="element-410">
            Regular Collagen Alone:
            <XIcon className="ml-2 text-[#E74C3C] h-5 w-5" data-id="element-411" />
          </h3>
          <ul className="space-y-8 text-[#2C3E50] font-['Inter']" data-id="element-412">
            <li className="flex items-center" data-id="element-413">
              <div className="bg-[#FFE5D9] p-3 rounded-full mr-4" data-id="element-414">
                <ClockIcon className="h-6 w-6 text-[#2C3E50]" data-id="element-415" />
              </div>
              <div data-id="element-416">
                <p className="font-medium text-[18px]" data-id="element-417">
                  Takes 90 days for results
                </p>
                <p className="text-[14px] text-[#7F8C8D]" data-id="element-418">
                  Slow absorption rate
                </p>
              </div>
              <XIcon className="ml-auto text-[#E74C3C] h-5 w-5" data-id="element-419" />
            </li>
            <li className="flex items-center" data-id="element-420">
              <div className="bg-[#FFE5D9] p-3 rounded-full mr-4" data-id="element-421">
                <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/im7RriDL3Uiwk6QeTp1UiH/Screenshot_2025-08-06_at_12.42.05_PM.png" alt="Broken brick wall" className="h-6 w-6 object-contain" data-id="element-422" />
              </div>
              <div data-id="element-423">
                <p className="font-medium text-[18px]" data-id="element-424">
                  Single brick wall (incomplete)
                </p>
                <p className="text-[14px] text-[#7F8C8D]" data-id="element-425">
                  Missing critical binding element
                </p>
              </div>
              <XIcon className="ml-auto text-[#E74C3C] h-5 w-5" data-id="element-426" />
            </li>
            <li className="flex items-center" data-id="element-427">
              <div className="bg-[#FFE5D9] p-3 rounded-full mr-4" data-id="element-428">
                <DropletIcon className="h-6 w-6 text-[#2C3E50]" data-id="element-429" />
              </div>
              <div data-id="element-430">
                <p className="font-medium text-[18px]" data-id="element-431">1X hydration</p>
                <p className="text-[14px] text-[#7F8C8D]" data-id="element-432">
                  Minimal moisture retention
                </p>
              </div>
              <XIcon className="ml-auto text-[#E74C3C] h-5 w-5" data-id="element-433" />
            </li>
          </ul>
        </div>
        {/* RIGHT COLUMN - Collagen + CERAMOSIDES™ */}
        <div className="bg-gradient-to-br from-[#FFB88C] to-[#FFE5D9] p-8 rounded-lg border border-[#FFB88C]/50 shadow-md hover:shadow-xl transition-all duration-300 hover:scale-[1.02]" data-id="element-434">
          <h3 className="text-[20px] md:text-[24px] font-semibold text-[#1B2951] mb-8 flex items-center font-['Poppins']" data-id="element-435">
            Collagen + CERAMOSIDES™:
            <CheckIcon className="ml-2 text-[#27AE60] h-5 w-5" data-id="element-436" />
          </h3>
          <ul className="space-y-8 text-[#1B2951]" data-id="element-437">
            <li className="flex items-center" data-id="element-438">
              <div className="bg-white/80 p-3 rounded-full mr-4 shadow-sm" data-id="element-439">
                <ZapIcon className="h-6 w-6 text-[#F4D03F]" data-id="element-440" />
              </div>
              <div data-id="element-441">
                <p className="font-semibold text-[18px]" data-id="element-442">Results in 15 days</p>
                <p className="text-[14px]" data-id="element-443">6X faster than standard formulas</p>
              </div>
              <CheckIcon className="ml-auto text-[#27AE60] h-5 w-5" data-id="element-444" />
            </li>
            <li className="flex items-center" data-id="element-445">
              <div className="bg-white/80 p-3 rounded-full mr-4 shadow-sm" data-id="element-446">
                <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/kokhSDzUCMsmhXT8nyCjzD/Screenshot_2025-08-06_at_12.42.53_PM.png" alt="Complete brick wall" className="h-6 w-6 object-contain" data-id="element-447" />
              </div>
              <div data-id="element-448">
                <p className="font-semibold text-[18px]" data-id="element-449">
                  Brick wall with mortar (complete)
                </p>
                <p className="text-[14px]" data-id="element-450">Total skin barrier protection</p>
              </div>
              <CheckIcon className="ml-auto text-[#27AE60] h-5 w-5" data-id="element-451" />
            </li>
            <li className="flex items-center" data-id="element-452">
              <div className="bg-white/80 p-3 rounded-full mr-4 shadow-sm flex" data-id="element-453">
                <DropletIcon className="h-6 w-6 text-[#3498DB]" data-id="element-454" />
                <span className="text-xs font-bold text-[#3498DB]" data-id="element-455">4X</span>
              </div>
              <div data-id="element-456">
                <p className="font-semibold text-[18px]" data-id="element-457">
                  4X hydration improvement
                </p>
                <p className="text-[14px]" data-id="element-458">
                  Clinically proven moisture retention
                </p>
              </div>
              <CheckIcon className="ml-auto text-[#27AE60] h-5 w-5" data-id="element-459" />
            </li>
          </ul>
        </div>
      </div>
      {/* 4X Hydration Graph */}
      <div className="mb-16 cursor-pointer hover:opacity-95 transition-opacity" onClick={() => openModal('https://uploadthingy.s3.us-west-1.amazonaws.com/enGAzoGyFU3t6FRUC7K1k8/Skin_Youthful_2025_PDP_-_9.2.jpg')} data-id="element-460">
        <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/enGAzoGyFU3t6FRUC7K1k8/Skin_Youthful_2025_PDP_-_9.2.jpg" alt="Graph showing 4X faster hydration with CERAMOSIDES™ in just 15 days compared to regular collagen" className="w-full rounded-lg shadow-md mb-3" data-id="element-461" />
        <p className="text-[14px] text-[#7F8C8D] text-center italic font-['Inter']" data-id="element-462">
          Clinical data shows how CERAMOSIDES™ achieves 4X faster hydration in
          just 15 days compared to standard collagen
        </p>
      </div>
      {/* Visible Hydration Boost Graph */}
      <div className="mb-16 cursor-pointer hover:opacity-95 transition-opacity" onClick={() => openModal('https://uploadthingy.s3.us-west-1.amazonaws.com/61KM31JMZbAGYDeBof4jTF/Skin_Youthful_2025_PDP_-_10.jpg')} data-id="element-463">
        <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/61KM31JMZbAGYDeBof4jTF/Skin_Youthful_2025_PDP_-_10.jpg" alt="Graph showing visible hydration boost with CERAMOSIDES™ increasing skin moisturization by 19% in 15 days and 27% in 60 days" className="w-full rounded-lg shadow-md mb-3" data-id="element-464" />
        <p className="text-[14px] text-[#7F8C8D] text-center italic font-['Inter']" data-id="element-465">
          Skin moisturization increases by 19% in just 15 days, reaching 27%
          improvement by day 60
        </p>
      </div>
      {/* Stronger Skin Barrier Graph */}
      <div className="mb-16 cursor-pointer hover:opacity-95 transition-opacity" onClick={() => openModal('https://uploadthingy.s3.us-west-1.amazonaws.com/cP7jLSF2ZuGQjMSQaGb3h5/Skin_Youthful_2025_PDP_-_11_.jpg')} data-id="element-466">
        <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/cP7jLSF2ZuGQjMSQaGb3h5/Skin_Youthful_2025_PDP_-_11_.jpg" alt="Graph showing reduced transepidermal water loss with CERAMOSIDES™ by 13% in 15 days and 15% in 60 days" className="w-full rounded-lg shadow-md mb-3" data-id="element-467" />
        <p className="text-[14px] text-[#7F8C8D] text-center italic font-['Inter']" data-id="element-468">
          Transepidermal water loss reduced by 13% in just 15 days,
          demonstrating a stronger skin barrier
        </p>
      </div>
      {/* Modal for expanded graphs */}
      {showModal && <div className="fixed inset-0 bg-black bg-opacity-75 flex items-center justify-center z-50 p-4" onClick={() => setShowModal(false)} data-id="element-469">
          <div className="bg-white rounded-lg p-4 max-w-4xl max-h-[90vh] overflow-auto" onClick={e => e.stopPropagation()} data-id="element-470">
            <img src={activeImage} alt="Expanded graph" className="w-full h-auto" data-id="element-471" />
            <button className="mt-6 bg-gradient-to-r from-[#FF8E72] to-[#FFB88C] text-white px-6 py-3 rounded-lg mx-auto block font-['Poppins'] font-semibold text-[16px] md:text-[18px]" onClick={() => setShowModal(false)} data-id="element-472">
              Close
            </button>
          </div>
        </div>}
    </section>;
}